import React from 'react'
import AddressLookup from 'components/Lookups/Address'
import InputWithLabel from './../../../../commons/InputWithLabel'

class HomeLoan extends React.Component {

  onChangeAddress = (address) => {
    const {
      locationFullAddress,
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
    } = address

    this.props.onChange({
      locationFullAddress,
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
    })
  }

  onChange = (params) => {
    this.props.onChange(params)
  }

  render() {
    const {
      minMonthlyRepayment,
      outstandingBalance,
      currentInterestRate,
      repaymentType,
      availableRedrawAmount,
      provider,
      owner,
      errors,
      locationFullAddress,
    } = this.props.commitment

    const {
      availableRepaymentTypeOptions,
      availableProviders,
      ownerOptions
    } = this.props

    return(
      <div className='card-body'>
        <AddressLookup
          inputGroupClass='w-100'
          placeholder='Address - e.g. 1 York Street, Sydney, NSW 2000'
          defaultValue={ locationFullAddress }
          onChange={ (result) => { this.onChangeAddress(result) } }
          errorMessage={ errors['locationFullAddress'] }
        />
        <InputWithLabel
          label="Outstanding balance"
          type='currency'
          defaultValue={ outstandingBalance }
          errorMessage={ errors['outstandingBalance'] }
          onChange={ (value) => { this.onChange({outstandingBalance: value}) } }
        />
        <InputWithLabel
          label="Current interest rate"
          type='append'
          appendText={ '%' }
          defaultValue={currentInterestRate}
          errorMessage={errors['currentInterestRate']}
          onChange={(value) => { this.onChange({currentInterestRate: value}); }}
        />
        <InputWithLabel
          label='Repayment type'
          type='select'
          borderStyle='responsive'
          defaultValue={repaymentType}
          errorMessage={errors['repaymentType']}
          options={availableRepaymentTypeOptions}
          onChange={(value) => { this.onChange({repaymentType: value}); }}
        />
        <InputWithLabel
          label="Minimum monthly repayment"
          type='currency'
          defaultValue={ minMonthlyRepayment }
          errorMessage={ errors['minMonthlyRepayment'] }
          onChange={ (value) => { this.onChange({minMonthlyRepayment: value}) } }
        />
        <InputWithLabel
          label="Available redraw amount"
          type='currency'
          defaultValue={availableRedrawAmount}
          errorMessage={errors['availableRedrawAmount']}
          onChange={(value) => { this.onChange({availableRedrawAmount: value}); }}
        />
        <InputWithLabel
          label='Provider'
          type='select'
          borderStyle='responsive'
          defaultValue={ provider }
          errorMessage={ errors['provider'] }
          options={ availableProviders }
          onChange={ (value) => { this.onChange({provider: value}) } }
        />
      {ownerOptions.length > 0 &&
        <InputWithLabel
          label='Owner'
          type='select'
          borderStyle='responsive'
          defaultValue={ owner }
          errorMessage={ errors['owner'] }
          options={ ownerOptions }
          onChange={ (value) => { this.onChange({owner: value}) } }
        />
      }
      </div>
    )
  }
}

export default HomeLoan;
